import React from "react";
import adobe from "../../../../../assets/images/AdobeStock.jpg"

export default function CloudDescription() {
  return (
    <section>
      <div className="">
        {/* top description */}
        <div className="flex flex-col py-8 mt-6 md:mt-14 px-6 md:flex-row md:space-x-16 md:px-10 xl:px-16">
          {/* image section */}
          <div className="w-full mx-auto md:-mt-0 ">
            <img
              alt=""
              src={adobe}
              className="w-full shadow-lg rounded h-full md:mb-0 object-center object-cover md:inset-0"
            />
          </div>

          {/* right text */}
          <div className="flex-col mt-10 md:mt-0 space-y-5 md:space-y-10 md:py-10 w-full">
            <div className="text-xl font-semibold text-black mx-auto  md:text-left">
              With a private cloud architecture to meet your organisation’s
              specific needs, private cloud solutions can be of real benefit to
              your business.
            </div>

            {/* text */}
            <div className="text-left text-gray-600 text-lg space-y-5 md:space-y-10">
              <p className="leading-7">
                Saving you time and money with a closed network & greater
                control benefits, manage your company’s data with our private
                cloud hosting services.{" "}
              </p>

              <p className="leading-7">
                With a private cloud architecture to meet your organisation’s
                specific needs, private cloud solutions can be of real benefit
                to your business. Saving you time and money with a closed
                network & greater control benefits, manage your company’s data
                with our private cloud hosting services.
              </p>
            </div>
            {/* button */}
            <div className="rounded-full w-40 md:w-52 py-2 border-2 border-primary100 text-center hover:bg-primary100 duration-500 hover:text-white">
              Get in touch
            </div>
          </div>
        </div>

        {/* middle description */}
        <div className="flex flex-col py-5 md:py-8 mt-3 md:mt-10 px-6 md:flex-row md:space-x-16 md:px-10 xl:px-16">
          {/* image section */}
          <div className="w-full md:hidden  mx-auto md:-mt-0 ">
            <img
              alt=""
              src={adobe}
              className="w-full md:hidden shadow-lg rounded h-full md:mb-0 object-center object-cover md:inset-0 "
            />
          </div>

          {/* left text */}
          <div className="flex-col mt-10 md:mt-0 space-y-5 md:space-y-10 md:py-10 w-full">
            <div className="text-3xl font-bold text-black mx-auto  md:text-left">
              Cloud computing solutions
            </div>

            {/* text */}
            <div className="text-left text-gray-600 text-xl space-y-5 md:space-y-10">
              <p className="leading-7">
                Our flexible and dynamic cloud solutions always put our clients
                first. With numerous cloud services available such as Microsoft
                365 Business, IaaS and Managed Services there will always be a
                combination which suits your business needs.{" "}
              </p>

              <p className="leading-7">
                All of our cloud services are on a subscription basis, meaning
                business leaders only pay for the solutions and services they
                require. With our flexible plans, subscriptions can be
                streamlined to suit changing business requirements.
              </p>
              <p className="leading-7">
                Our cloud computing services will grow (or shrink) with your
                business, so you only ever pay for what you need. Every package
                is tailored for your ndividual business requirements.
              </p>
            </div>
            {/* button */}
            <div className="rounded-full w-40 md:w-52 py-2 border-2 border-sky-400 text-center hover:bg-sky-400 duration-500 hover:text-white">
              Get in touch
            </div>
          </div>

          {/* image section */}
          <div className="w-full mx-auto md:-mt-0 ">
            <img
              alt=""
              src={adobe}
              className="w-full hidden md:block shadow-lg rounded h-full   md:mb-0 object-center object-cover md:inset-0 "
            />
          </div>
        </div>

        {/* last description */}
        <div className="flex flex-col bg-slate-100 py-6 md:py-12 mt-10 md:mt-20 px-6 md:flex-row md:space-x-16 md:px-10 xl:px-16">
          {/* image section */}
          <div className="w-full  mx-auto md:-mt-0 ">
            <img
              alt=""
              src={adobe}
              className="w-full shadow-lg rounded h-full md:mb-0 object-center object-cover md:inset-0 "
            />
          </div>

          {/* right text */}
          <div className="flex-col mt-10 md:mt-0 space-y-5 md:space-y-10 py-5 md:py-10 w-full">
            <div className="text-3xl font-bold text-black mx-auto  md:text-left">
              Trusted Cloud computing services
            </div>

            {/* text */}
            <div className="text-left text-gray-600 text-xl space-y-5 md:space-y-10">
              <p className="leading-7 font-semibold text-black text-xl">
                At TPS we work very closely with our clients, ensuring they have
                the cloud services that they need to achieve their business
                goals, as well as providing excellent ongoing support.{" "}
              </p>

              <p className="leading-7">
                With a private cloud architecture to meet your TPS have been
                industry leaders for more than 10 years and have worked closely
                with numerous organisations helping them grow and develop as
                well as keeping their data and IT network safe.
              </p>
              <p className="leading-7">
                It’s important for us that our clients’ businesses are running
                24/7 and we do all within our power to prevent downtime, but
                should the worst happen we get the systems up and running as
                quickly as possible. We put our customers first, consistently
                delivering fast response times and a high standard of
                resolution our clients can rely on.
              </p>
            </div>
            {/* button */}
            <div className="rounded-full w-40 md:w-52 py-2 border-2 border-primary100 text-center hover:bg-primary100 duration-500 hover:text-white">
              Get in touch
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
